import ApiPrevmet from './Prevmet.js'

const MAX_TENTATIVAS = 4
const INTERVALO_MS = 2000

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export const isAvisosValidos = (data) => {
  return data
    && typeof data === 'object'
    && Array.isArray(data.hoje)
    && Array.isArray(data.futuro)
}

export const isAvisoValido = (data) => {
  return data
    && typeof data === 'object'
    && !Array.isArray(data)
    && data.poligono
    && data.descricao
}

export const fetchAvisoById = async (id) => {
  for (let tentativa = 1; tentativa <= MAX_TENTATIVAS; tentativa++) {
    try {
      const res = await ApiPrevmet.get(`/aviso/getByID/${id}`)
      if (isAvisoValido(res.data)) {
        return res.data
      }
    } catch (err) {
      console.log(err)
    }

    if (tentativa < MAX_TENTATIVAS) {
      await sleep(INTERVALO_MS)
    }
  }

  throw new Error('Erro ao carregar aviso')
}

export const fetchAvisosAtivos = async () => {
  for (let tentativa = 1; tentativa <= MAX_TENTATIVAS; tentativa++) {
    try {
      const res = await ApiPrevmet.get('/avisos/ativos')
      if (isAvisosValidos(res.data)) {
        return res.data
      }
    } catch (err) {
      console.log(err)
    }

    if (tentativa < MAX_TENTATIVAS) {
      await sleep(INTERVALO_MS)
    }
  }

  throw new Error('Erro ao carregar avisos')
}
